import axios from 'axios';
import { getUserName, getUserToken } from '../../utils/localStoarege';
import { localToken, newHudGetMedicineOintmentsApiUrl, newHudGetMedicineTabletsApiUrl, newHudPatientApiCRUDUrl, newHudAddPatintPackageInvoiceUrl, newClinicHudPackageApiCRUDUrl, newHudPackageApiCRUDUrl, newHudDoctoViewPatchUrl, newClinicApprovalPatientApiCRUDUrl, todayFilteredPatientsList, patientPackageApprovalImageUrl } from '../../constants/apis/new_hud_apis';

export const getNewHudPatients = async (query) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + "?branch=" + getUserName() + query, config);
    return response;
};

export const getNewHudPatientsFilteredToday = async (center, query) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(todayFilteredPatientsList + center + query, config);
    return response;
};

export const getNewHudPatientsHistory = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/history/", config);
    return response;
};

export const getNewHudPatientsPhotos = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/photos/", config);
    return response;
};

export const getNewHudPatientsPhotoOfDates = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/unique_photo_date/", config);
    return response;
};

export const postNewHudPatientsPhotos = async (patintId, data) => {
    const token = localToken;
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudPatientApiCRUDUrl + patintId + "/photos/", data, config);
    return response;
};

export const getNewHudPatientsPdfs = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/pdfs/", config);
    return response;
};

export const postNewHudPatientsPdfs = async (patintId, data) => {
    const token = localToken;
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudPatientApiCRUDUrl + patintId + "/pdfs/", data, config);
    return response;
};

export const deleteNewHudPatientsPdfs = async (patintId, id) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.delete(newHudPatientApiCRUDUrl + patintId + "/pdfs/" + id + "/", config);
    return response;
};

export const deleteNewHudPatientsPhoto = async (patintId, id) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.delete(newHudPatientApiCRUDUrl + patintId + "/photos/" + id + "/", config);
    return response;
};

export const patchNewHudPatientsHistory = async (patintId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newHudPatientApiCRUDUrl + patintId + "/history/", data, config);
    return response;
};


export const postNewRating = async (patintId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudPatientApiCRUDUrl + patintId + "/ratings/", data, config);
    return response;
};

export const newPostNewHudPatient = async (data) => {
    const config = {
        headers: {
            Authorization: `Token ${localToken}`,
        },
    };

    const response = await axios.post(newHudPatientApiCRUDUrl, data, config);
    return response;
};

export const newPatchPatient = async (id, data) => {
    const config = {
        headers: {
            Authorization: `Token ${localToken}`,
        },
    };

    const response = await axios.patch(`${newHudPatientApiCRUDUrl}${id}/`, data, config);
    return response;
};

export const getNewHudPatientsPackages = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/packages/", config);
    return response;
};

export const getNewHudPatientsPackageApprovals = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/approval-images/", config);
    return response;
};

export const postNewHudPatientsPackageApprovals = async (data) => {
    const token = localToken;
    const config = {
        headers: {
            // "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(patientPackageApprovalImageUrl, data, config);
    return response;
};

export const addNewHudPatientPackageComment = async (packageId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudPackageApiCRUDUrl + packageId + "/add-comment/", data, config);
    return response;
};

export const addNewHudPatientPackage = async (patientId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudPatientApiCRUDUrl + patientId + "/add-package/", data, config);
    return response;
};

export const patchNewHudPatientPackage = async (patientId, packgeId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newHudPatientApiCRUDUrl + patientId + "/update-package/" + packgeId + "/", data, config);
    return response;
};

export const updateNewHudPatientPackage = async (patientId, packageId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newHudPatientApiCRUDUrl + patientId + "/update-package/" + packageId + "/", data, config);
    return response;
};

export const updateNewHudPatientDoctorView = async (center, patientId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newHudDoctoViewPatchUrl + (center || getUserName()) + "/", { patient_id: patientId }, config);
    return response;
};

export const addNewHudPatientPackageInvoice = async (data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudAddPatintPackageInvoiceUrl, data, config);
    return response;
};

export const patchNewHudPatientPackageApproval = async (id, data) => {
    const token = localToken;
    const config = {
        headers: {
            // "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newClinicHudPackageApiCRUDUrl + id + "/", data, config);
    return response;
};

export const getNewHudPatientsOintments = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/ointments/", config);
    return response;
};

export const getNewHudPatientsPhotosOfDate = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/unique_photo_date/", config);
    return response;
};

export const getNewHudPatientsTablets = async (patintId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPatientApiCRUDUrl + patintId + "/tablets/", config);
    return response;
};

export const postNewHudMedicineChanges = async (data, patientId) => {
    const config = {
        headers: {
            Authorization: `Token ${localToken}`,
        },
    };

    const response = await axios.post(newHudPatientApiCRUDUrl + patientId + "/add-medicine/", data, config);
    return response;
};

export const getNewHudTablets = async () => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudGetMedicineTabletsApiUrl, config);
    return response;
};

export const getNewHudOintments = async () => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudGetMedicineOintmentsApiUrl, config);
    return response;
};
